export const ONBOARDING_STEPS = Object.freeze({
  motivation: 0,
  selectCoach: 1,
  connect: 2
});
